import CryptoJS from 'crypto-js';

const SECRET_KEY = import.meta.env.VITE_ENCRYPTION_KEY || '';

console.log('Encryption key loaded:', SECRET_KEY ? 'YES (length: ' + SECRET_KEY.length + ')' : 'NO - Please restart dev server after creating .env file');

// Get properly formatted encryption key (32 bytes for AES-256)
const getKey = () => {
  if (!SECRET_KEY) {
    const error = 'ENCRYPTION KEY NOT FOUND! Please ensure .env file exists with VITE_ENCRYPTION_KEY and restart the dev server.';
    console.error(error);
    throw new Error(error);
  }
  return CryptoJS.enc.Utf8.parse(SECRET_KEY.substring(0, 32));
};

// Function to encrypt data (matches backend format)
export const encryptData = (data: unknown): string => {
  try {
    console.log('Encrypting data...');
    const key = getKey();

    // Convert data to string
    const dataUtf8 = CryptoJS.enc.Utf8.parse(JSON.stringify(data));

    // Generate random IV
    const iv = CryptoJS.lib.WordArray.random(16);

    // Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(dataUtf8, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Combine IV and ciphertext and encode as base64
    const encryptedData = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);

    console.log('Encryption successful');
    return encryptedData;
  } catch (error) {
    console.error('Encryption error:', error);
    throw new Error(`Encryption failed: ${error}`);
  }
};

// Function to decrypt data (matches backend format)
export const decryptData = <T = unknown>(encryptedData: string): T => {
  try {
    const key = getKey();

    // Decode the base64-encoded data
    const encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedData);

    // Separate the IV and ciphertext
    const iv = CryptoJS.lib.WordArray.create(encryptedWordArray.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedWordArray.words.slice(4));

    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext } as CryptoJS.lib.CipherParams,
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    // Convert to UTF-8 string and parse JSON
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString) as T;
  } catch (error) {
    console.error('Decryption error:', error);
    throw new Error(`Decryption failed: ${error}`);
  }
};
